import React, { useState, useEffect } from 'react'
import './App.css'
import './Profile.css'
import './Marketing.css'
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import {
  IoMailOutline,
  IoChatbubbleOutline,
  IoCloudUploadOutline,
  IoWarningOutline,
} from 'react-icons/io5'
import ClipLoader from 'react-spinners/ClipLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { BiMenu } from 'react-icons/bi'
import Header5 from './components/Header5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import { API_URL } from './config'

const Uploaddata = () => {
  const history = useHistory()

  const [marketingType, setMarketingType] = useState('SMS')
  const [alias] = useState(localStorage.getItem('alias'))

  const [attachment, setAttachment] = useState('')
  const [attachmentLabel, setAttachmentLabel] = useState('Upload the file')
  const [attachmentName, setAttachmentName] = useState('')

  const [loading, setLoading] = useState(false)
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [error, setError] = useState('')
  const [responsebg, setResponseBG] = useState('error-login')

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState(isMobile)
  const [collapsed, setCollapsed] = useState(isMobile)

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    document.title = 'Marketing campaign'

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [])

  async function next() {
    setLoading(true)
    setErrorDisplay('none')

    const businessid = localStorage.getItem('businessid')

    const data = new FormData()
    data.append('file', attachment)
    data.append('businessid', businessid)
    data.append('subqueryone', marketingType) // SMS OR EMAIL
    data.append('subquerytwo', alias) // EXISTINGAUDIENCE OR NEWAUDIENCE
    data.append('query', 'UPLOAD-MARKETING-DATA')

    if (attachment == '') {
      setErrorDisplay('block')
      setError('Upload file')
      setResponseBG('error-login')
      setLoading(false)
    } else {
      await axios({
        url: `${API_URL}/apps/kscanner/webservices.php`,
        method: 'POST',
        data,
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((response) => {
        if (response.data.status === 'success') {
          localStorage.setItem('alias', 'NEWAUDIENCE')
          localStorage.setItem('type', marketingType)

          history.push({
            pathname: 'marketing',
          })
        } else {
          setErrorDisplay('block')
          setError(response.data.message)
          setResponseBG('error-login')
        }

        setLoading(false)
      })

      setTimeout(() => {
        setErrorDisplay('none')
      }, 4000)
    }
  }

  function email() {
    setMarketingType('EMAIL')
    setErrorDisplay('none')
  }

  function sms() {
    setMarketingType('SMS')
    setErrorDisplay('none')
  }

  function removeAttachment() {
    setAttachmentLabel('Upload the file')
    setAttachment('')
    setAttachmentName('')
    setErrorDisplay('none')
  }

  function selectFile(event) {
    const file = event.target.files[0]
    if (!file) return
    setAttachment(file)
    setAttachmentName(file.name)
    setAttachmentLabel('Re-upload the file')
    setErrorDisplay('none')
  }

  if (localStorage.getItem('businessname') === null) {
    return <Redirect to="/login" />
  }

  const accounttype = localStorage.getItem('accounttype')
  const handleToggle = () => setCollapsed((prev) => !prev)

  const isSms = marketingType === 'SMS'
  const isEmail = marketingType === 'EMAIL'

  return (
    <div className="view">
      {accounttype === 'customer' ? (
        <>
          <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
          <Header />
        </>
      ) : accounttype === 'business' ? (
        <>
          <SideNav collapsed={collapsed} onToggle={handleToggle} />
          <Header />
        </>
      ) : (
        <Header5 />
      )}

      {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

      {isMob && collapsed && (
        <label className="mobile-toggle" onClick={handleToggle}>
          <BiMenu size={25} />
        </label>
      )}

      <main
        className="pf-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? 0 : collapsed ? '76px' : '252px',
        }}
      >
        <div className="pf-container">
          <div className="pf-top">
            <button type="button" className="pf-back" onClick={() => history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <button
              type="button"
              className="pf-edit mk-send"
              onClick={next}
              disabled={attachment == '' || loading}
            >
              {loading ? <ClipLoader color={'#fff'} loading={true} size={16} /> : 'Upload'}
            </button>
          </div>

          {/* Channel */}
          <section className="pf-card">
            <div className="pf-card__head">
              <h2>
                <IoChatbubbleOutline size={18} />
                Choose communication
              </h2>
            </div>

            <div className="mk-body">
              <div className="mk-options">
                <button
                  type="button"
                  className={`mk-option ${isSms ? 'mk-option--active' : ''}`}
                  onClick={sms}
                >
                  <IoChatbubbleOutline size={20} />
                  <span>SMS</span>
                </button>
                <button
                  type="button"
                  className={`mk-option ${isEmail ? 'mk-option--active' : ''}`}
                  onClick={email}
                >
                  <IoMailOutline size={20} />
                  <span>Email</span>
                </button>
              </div>
            </div>
          </section>

          {/* SMS offline / Upload steps */}
          {isSms ? (
            <section className="pf-card">
              <div className="mk-body mk-notice">
                <IoWarningOutline size={56} />
                <p>
                  SMS communications are temporarily offline. Kindly direct all communication via
                  email.
                </p>
              </div>
            </section>
          ) : (
            <section className="pf-card">
              <div className="pf-card__head">
                <h2>
                  <IoCloudUploadOutline size={18} />
                  Upload your own data
                </h2>
              </div>

              <dl className="pf-grid">
                <div className="pf-field pf-field--wide">
                  <dt>Step 1</dt>
                  <dd>
                    <a
                      className="pf-link"
                      href={`${API_URL}/apps/kscanner/structure/email_structure.csv`}
                      target="_top"
                    >
                      Download email structure
                    </a>
                  </dd>
                </div>

                <div className="pf-field pf-field--wide">
                  <dt>Step 2</dt>
                  <dd>Fill in data</dd>
                </div>

                <div className="pf-field pf-field--wide">
                  <dt>Step 3</dt>
                  <dd>
                    <label className="mk-attach" htmlFor="image">
                      {attachmentLabel}
                    </label>
                    {attachmentName && (
                      <div className="mk-file mk-file--inline">
                        <span className="mk-file__name">{attachmentName}</span>
                        <button
                          type="button"
                          className="mk-file__remove"
                          onClick={removeAttachment}
                        >
                          Remove attachment
                        </button>
                      </div>
                    )}
                    <input
                      name="file"
                      type="file"
                      onChange={selectFile}
                      id="image"
                      className="hide-file-input-type"
                    />
                  </dd>
                </div>
              </dl>
            </section>
          )}
        </div>
      </main>

      <div className={responsebg + ' text-center'} style={{ display: errorDisplay }}>
        {error}
      </div>
    </div>
  )
}

export default Uploaddata
